import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function RouteChangeListener() {
    const location = useLocation();
    const prevPathRef = useRef(null);
    useEffect(() => {
        // Skip on first load
        if (prevPathRef.current !== null && prevPathRef.current !== location.pathname) {
            // Route actually changed → clear specific key or entire localStorage
            localStorage.removeItem("query"); 
            console.log("Removed 'query' from localStorage on route change:", location.pathname);
        }
        // Update previous path
        prevPathRef.current = location.pathname;
    }, [location.pathname]);

    return null;
}

export default RouteChangeListener;